import { LANGUAGE_DEFAULT, LANGUAGE_KEY } from "@/store/constants";
import http from "@/utils/axios.js";
export default {
  namespaced: true,
  state: {
    currentLanguage: null,
  },
  getters: {
    getCurrentLanguage: (state) => state.currentLanguage,
  },
  mutations: {
    setCurrentLanguage(state, language) {
      state.currentLanguage = language;
    },
  },
  actions: {
    initCurrentLanguage({ commit, rootGetters }) {
      let language =
        localStorage.getItem(LANGUAGE_KEY) || navigator.language.substring(0, 2);

      if (
        !rootGetters["languages/getAllLanguages"]
          .map((lang) => lang.code)
          .includes(language)
      ) {
        language = LANGUAGE_DEFAULT
      }

      commit(
        "setCurrentLanguage",
        rootGetters["languages/getLanguageByCode"](language)
      );
    },

    setCurrentLanguageByCode({ commit, rootGetters }, code) {
      localStorage.setItem(LANGUAGE_KEY, code);
      http.defaults.headers["Accept-Language"] = code;
      commit(
        "setCurrentLanguage",
        rootGetters["languages/getLanguageByCode"](code)
      );
    },
  },
};
